export const isOverlay = (alignment: string | undefined) =>
  alignment === 'leftOverlay' ||
  alignment === 'rightOverlay' ||
  alignment === 'centerOverlay';
